import React from "react";
import { Box, Skeleton, Stack, useMediaQuery, useTheme } from "@mui/material";

const SliderSkeletonLoader: React.FC = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <Box
            sx={{
                width: isMobile ? "100%" : "100%",
                maxWidth: isMobile ? 350 : "100%",
                marginX: "auto",
                padding: isMobile ? "0 1rem" : "0 3.5rem",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                bgcolor: "background.paper"
            }}
        >
            <Box
                display="flex"
                flexDirection={isMobile ? "column" : "row"}
                justifyContent={isMobile ? "center" : "space-between"}
                alignItems={isMobile ? "center" : "flex-start"}
                mb={0}
                gap={isMobile ? 2 : 0}
            >
                <Stack spacing={0} marginTop={isMobile ? 4 : 0} alignItems={isMobile ? "center" : "flex-start"} sx={{ width: isMobile ? "100%" : "auto" }}>
                    {!isMobile && <Skeleton variant="text" width={100} height={30} />}
                    {isMobile ? (
                        <Skeleton variant="rectangular" width="100%" height={isMobile ? 100 : 200} />
                    ) : (
                        <Skeleton variant="text" width={220} height={90} />
                    )}
                </Stack>

                {!isMobile && <Stack spacing={0} alignItems={isMobile ? "center" : "flex-end"}>
                    <Skeleton variant="text" width={100} height={30} />
                    <Skeleton variant="text" width={220} height={90} />
                </Stack>}
            </Box>

            <Skeleton variant="rectangular" height={1} />

            <Box display="flex" alignItems="center" mb={8} mt={5}>
                <Skeleton variant="circular" width={30} height={30} />
                <Skeleton variant="rectangular" width="100%" height={8} sx={{ mx: 2, borderRadius: 2 }} />
                <Skeleton variant="circular" width={30} height={30} />
            </Box>

            <Box display="flex" alignItems="center" mb={4}>
                <Skeleton variant="circular" width={30} height={30} />
                <Skeleton variant="rectangular" width="100%" height={8} sx={{ mx: 2, borderRadius: 2 }} />
                <Skeleton variant="circular" width={30} height={30} />
            </Box>

            <Box
                display="flex"
                flexDirection={isMobile ? "column" : "row"}
                justifyContent={isMobile ? "center" : "space-between"}
                alignItems="center"
                mt="auto"
                gap={isMobile ? 2 : 0}
            >
                {!isMobile && <>
                    <Stack spacing={1} alignItems="center">
                        <Skeleton variant="text" width={90} height={25} />
                        <Skeleton variant="text" width={60} height={15} />
                    </Stack>
                    <Stack spacing={1} alignItems="center">
                        <Skeleton variant="text" width={110} height={25} />
                        <Skeleton variant="text" width={80} height={15} />
                    </Stack>

                    <Stack spacing={1} alignItems="center">
                        <Skeleton variant="text" width={90} height={25} />
                        <Skeleton variant="text" width={60} height={15} />
                    </Stack>
                </>}
                <Skeleton
                    variant="rectangular"
                    width={isMobile ? "100%" : 140}
                    height={isMobile ? 150 : 50}
                />
            </Box>
        </Box>
    );
};

export default SliderSkeletonLoader;